/**
 * @ngInject
 */
export class BsDropdownBoundaryDirectiveController {
    constructor($element) {
        this.$element = $element;
    }
}
export function bsDropdownBoundaryDirective() {
    return {
        restrict: 'A',
        controller: BsDropdownBoundaryDirectiveController
    };
}
